import { deleteURLArg } from '@/utils/common'
import '@/lib/tx-sns-auth/authLogin'
import { post, get } from '@/utils/api'

var dev = authLogin.dev();//判断所属社交平台。
if (!dev) { //无法判断所属平台时。
    authLogin.def = 'weibo';//配置当前页面 无法判断所属平台 打开时，使用哪个平台的授权，可配置值 weixin,qq,weibo,facebook,line,twitter。不配置则自动判断当前所属平台，国内平台判断会正常，海外的判断不了平台，海外的项目需要指定一下
}

function getSnsLoginParams() {
    var myurl = authLogin.urlps(location.href);
    var dev = authLogin.dev() || authLogin.def;
    var code = '';
    var ap = '';
    var dobj = {};
    switch (dev) {
        case 'weixin':
            code = myurl.data('code');
            dobj.code = code;
            ap = 'wx/login';
            break;
        case 'qq':
            code = myurl.data('code');
            dobj.code = code;
            dobj.redirect_uri = decodeURIComponent(myurl.data("rurl"));
            ap = 'qq/login';
            break;
        case 'weibo':
            code = myurl.data('code');
            dobj.code = code;
            dobj.redirect_uri = "https://game.163.com/weibo/callback/";
            ap = 'weibo/login';
            break;
        case 'facebook':
            code = myurl.data('code');
            dobj.code = code;
            dobj.redirect_uri = authLogin.config.fbCallback;
            ap = 'fb/login';
            break;
        case 'line':
            code = myurl.data('code');
            dobj.code = code;
            dobj.redirect_uri = authLogin.config.lineCallback;
            ap = 'line/login';
            break;
        case 'twitter':
            code = myurl.data('oauth_token');
            dobj.oauth_token = code;
            dobj.oauth_verifier = myurl.data("oauth_verifier");
            ap = 'twitter/login';
            break;
    }
    return { ap, dobj, dev }
}

class ServerApi {
    snsLogin = async () => {
        const { ap, dobj, dev } = getSnsLoginParams()

        dobj.project = import.meta.env.VITE_NAME
        dobj.activity = import.meta.env.VITE_TEAM
        dobj.auth_code = dobj.code

        console.log('登录apppp:' + ap)

        let ret = await post(`${import.meta.env.VITE_BASEAPI}/user/auth/common/social/${ap}`, dobj)
        let isLoginSuccess = ret.code == 1
        if (isLoginSuccess) {
            console.log('登录成功:' + dev)
        } else {
            console.log('登录失败:' + dev)
        }
        // 去掉code参数，避免重新登录时使用无效的code
        window.history.replaceState(null, null, deleteURLArg(location.href, 'code'))
        return isLoginSuccess
    }

    snsLogout = async () => {
        const data = {}
        data.project = import.meta.env.VITE_NAME
        data.activity = import.meta.env.VITE_TEAM
        const ret = await post(`${import.meta.env.VITE_BASEAPI}/user/auth/common/social/sns/logout`, data)
        console.log(ret)
    }


    checkLogin = async (callback) => {
        if (!authLogin.check('game')) {
            authLogin.go()
        } else {
            const isLoginSuccess = await this.snsLogin()
            console.log("isLoginSuccess", isLoginSuccess)
            if (isLoginSuccess) {
                callback()
            }
        }
    }

    // 获取社媒用户角色
    getSnsUserInfo = async () => {
        const ret = await get(`${import.meta.env.VITE_BASEAPI}/user/auth/common/social/get_userinfo`)
        return ret
    }
}

export default {
    sns: new ServerApi()
}
